
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[part1]/[part2]",
      function () {
        return require("private-next-pages/[lang]/[part1]/[part2]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[part1]/[part2]"])
      });
    }
  